import { render } from "./VideoPlayerExport.vue?vue&type=template&id=7bec5e99&ts=true"
import script from "./VideoPlayerExport.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerExport.vue?vue&type=script&lang=ts"

import "./VideoPlayerExport.vue?vue&type=style&index=0&id=7bec5e99&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__